import { FC, useMemo } from 'react';

import CustomMultiSelect from '@/components/Filtering/CustomMultiSelect.tsx';

import { useResolvedPracticeSelection } from '@/hooks/use-task-filter-selection.ts';
import useConfig from '@/hooks/useConfig.ts';
import useFilters from '@/hooks/useFilters.ts';

import { useFilterStore } from '@/stores/filterStore.ts';

const PracticeSelect: FC = () => {
    const { location_key } = useConfig();
    const { practice_options: practices } = useFilters();
    const { all_options, values } = useResolvedPracticeSelection();

    const display_text = useMemo(() => {
        if (values.length === 0) return 'Keine Praxen';
        if (values.length === all_options.length) return `Alle Praxen (${practices.length})`;
        return `Ausgewählte Praxen (${values.length})`;
    }, [values.length, all_options.length, practices.length]);

    const handleToggle = (id: string): void => {
        const new_selected = values.includes(id) ? values.filter((value) => value !== id) : [...values, id];

        useFilterStore.setState((state) => ({
            selected_practices: {
                ...state.selected_practices,
                [location_key]: new_selected,
            },
        }));
    };

    const handleSelectAll = (): void => {
        if (values.length === all_options.length) {
            useFilterStore.setState((state) => ({
                selected_practices: {
                    ...state.selected_practices,
                    [location_key]: [],
                },
            }));
        } else {
            useFilterStore.setState((state) => ({
                selected_practices: {
                    ...state.selected_practices,
                    [location_key]: all_options.map((option) => option.value),
                },
            }));
        }
    };

    return (
        <CustomMultiSelect
            label="Alle Praxen"
            displayText={display_text}
            options={all_options}
            selected={values}
            handleToggle={handleToggle}
            handleSelectAll={handleSelectAll}
        />
    );
};

export default PracticeSelect;
